export class Util {
  constructor() {
    this.noInteracts = document.querySelectorAll('input, textarea, select, button, a');
    this.spinnerElm = document.createElement('div');
    this.spinnerElm.classList.add('spinner-border');
    this.spinnerElm.innerHTML = '<span class="visually-hidden">Loading...</span>';
    this.overlay = document.createElement('div');
    this.overlay.classList.add('overlay');
    Date.prototype.yyyymmdd = function (delimiter = '-') {
      const mm = this.getMonth() + 1; // getMonth() is zero-based
      const dd = this.getDate();
      return [this.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join(delimiter);
    };
  }
  loadScript(url, callback) {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.onload = () => {
      if (callback !== undefined) {
        callback();
      }
    };
    script.src = url;
    document.body.appendChild(script);
  }
  loadCss(url) {
    const head = document.querySelector('head');
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = url;
    head.appendChild(link);
  }
  spinnerStart() {
    document.body.classList.add('loading');
    document.body.prepend(this.spinnerElm);
    document.body.prepend(this.overlay);
    this.noInteracts.forEach(elm => elm.addEventListener("keydown", this.disableKeys));
  }
  spinnerStop() {
    document.body.classList.remove('loading');
    document.body.removeChild(this.spinnerElm);
    document.body.removeChild(this.overlay);
    this.noInteracts.forEach(elm => elm.removeEventListener("keydown", this.disableKeys));
  }
  isInView(el) {
    const box = el.getBoundingClientRect();
    return box.top < window.innerHeight && box.bottom >= 0;
  }
  disableKeys() {
    return false;
  }
  bootstrapWasValidated() {
    const emailFields = document.querySelectorAll('[type=email]');
    if (emailFields.length > 0) {
      emailFields.forEach(emailField => this.addEmailPattern(emailField));
    }
    const submitBtns = document.querySelectorAll('button[type="submit"]');
    submitBtns.forEach(submitBtn => {
      submitBtn.addEventListener('click', e => this.wasValidated(submitBtn));
    });
  }
  wasValidated(submitBtn) {
    const form = submitBtn.closest('form');
    form.classList.add('was-validated');
  }
  addEmailPattern(emailField) {
    emailField.setAttribute('pattern', '[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,63}');
  }
  addAsteriskRequiredFieldsLabel() {
    const requiredFields = document.querySelectorAll('[required]:not([type=checkbox]):not([type=radio])');
    requiredFields.forEach(requiredField => {
      let fieldId = requiredField.getAttribute('id');
      let forLabel = document.querySelector('[for=' + fieldId + ']');
      if (forLabel) {
        forLabel.classList.add('required');
      }
    });
    const requiredRadioCheckboxes = document.querySelectorAll('[type=checkbox][required],[type=radio][required]');
    requiredRadioCheckboxes.forEach(requiredRadioCheckbox => {
      let fieldId = requiredRadioCheckbox.getAttribute('id');
      let forLabel = document.querySelector('[for=' + fieldId + ']');
      if (forLabel) {
        forLabel.append("*");
      }
    });
  }
  addPasswordEye() {
    const passwordFields = document.querySelectorAll('input[type=password]');
    passwordFields.forEach(passwordField => {
      const eyes = document.createElement('span');
      eyes.classList.add('input-group-text', 'cursor-pointer');
      const eye = document.createElement('i');
      eye.classList.add('fa-light', 'fa-eye', 'fa-fw');
      const eyeSlash = document.createElement('i');
      eyeSlash.classList.add('fa-light', 'fa-eye-slash', 'fa-fw', 'd-none');
      eyes.append(eye, eyeSlash);
      eyes.addEventListener('click', () => {
        eye.classList.toggle('d-none');
        eyeSlash.classList.toggle('d-none');
        const type = passwordField.type === 'password' ? 'text' : 'password';
        passwordField.setAttribute('type', type);
      });
      passwordField.parentNode.appendChild(eyes);
    });
  }
  validateFormRequiredFields(form) {
    const fields = form.querySelectorAll('[required]');
    for (const field of fields) {
      if (field.type === "checkbox") {
        if (!field.checked) {
          return false;
        }
      } else if (!field.value) {
        return false;
      }
      if (field.hasAttribute('pattern')) {
        const pattern = field.getAttribute('pattern');
        const regex = new RegExp(pattern, 'g');
        if (!regex.test(field.value)) {
          return false;
        }
      }
    }
    return true;
  }
  priceCalculate(e, vat, commaPrecision = 10000) {
    let elem;
    if (e.target) {
      elem = e.currentTarget;
    } else {
      elem = e;
    }

    // Lav excl/incl tomt hvis man intet skriver i det modsatte
    if (elem.value === '') {
      return null;
    }
    const price = parseInt(elem.value * commaPrecision);
    const vatPrecision = parseInt(vat * commaPrecision);
    const dividerPrecision = 100 * commaPrecision;
    let newPrice = 0;
    if (elem.getAttribute("data-type") === "excl") {
      newPrice = price * (1 + vatPrecision / dividerPrecision);
    } else {
      newPrice = price / (1 + vatPrecision / dividerPrecision);
    }
    let priceTimes100 = newPrice / (commaPrecision / 100);
    newPrice = newPrice / commaPrecision;
    if (priceTimes100 === parseInt(priceTimes100)) {
      return newPrice.toFixed(2);
    } else {
      return newPrice.toFixed(4);
    }
  }
  dateDaysOptions(placeholder, selectedDay) {
    selectedDay = selectedDay ? selectedDay.toString() : null;
    let days = `<option value="" disabled hidden ${!selectedDay ? 'selected' : ''}>${placeholder}</option>`;
    for (let i = 1; i <= 31; i++) {
      const value = i.toString().padStart(2, '0');
      const selected = value === selectedDay ? 'selected' : '';
      days += '<option value="' + value + '" ' + selected + '>' + i + '</option>';
    }
    return days;
  }
  dateMonthOptions(placeholder, monthsNames, selectedMonth) {
    selectedMonth = selectedMonth ? selectedMonth.toString() : null;
    let months = `<option value="" disabled hidden ${!selectedMonth ? 'selected' : ''}>${placeholder}</option>`;
    for (let key in monthsNames) {
      const monthNumber = parseInt(key) + 1;
      const value = monthNumber.toString().padStart(2, '0');
      const selected = value === selectedMonth ? 'selected' : '';
      months += '<option value="' + value + '" ' + selected + '>' + monthsNames[key] + '</option>';
    }
    return months;
  }
  dateYearsOptions(placeholder, selectedYear, yearsGoBack = 125) {
    selectedYear = selectedYear ? parseInt(selectedYear) : null;
    let years = `<option value="" disabled hidden ${!selectedYear ? 'selected' : ''}>${placeholder}</option>`;
    let currentYear = new Date().getFullYear();
    const lastYear = currentYear - yearsGoBack;
    for (currentYear; currentYear > lastYear; currentYear--) {
      const selected = currentYear === selectedYear ? 'selected' : '';
      years += '<option value="' + currentYear + '" ' + selected + '>' + currentYear + '</option>';
    }
    return years;
  }
  setBirthdayField(birthdayField, day, month, year) {
    if (!day.value || !month.value || !year.value) {
      birthdayField.value = '';
      return;
    }
    birthdayField.value = year.value + '-' + month.value + '-' + day.value;
  }
  appendHtml(parent, html) {
    parent.insertAdjacentHTML('beforeend', html);
  }
  addClass(element, classname) {
    if (!element) return;
    if (this.hasClass(element, classname)) return;
    if (element.classList.length === 0) {
      element.className = classname;
    } else {
      element.className = element.className + ' ' + classname;
    }
    element.className = element.className.replace(/  +/g, ' ');
    //else element.classList.add(classname); //error if there is -
  }
  addClasses(elms, classname) {
    for (let i = 0; i < elms.length; i++) {
      elms[i].classList.add(classname);
    }
  }
  removeClass(element, classname) {
    if (!element) return;
    if (element.classList.length > 0) {
      // element.className = element.className.replace(new RegExp('\\b'+ classname+'\\b', 'g'), '');
      // element.className = element.className.replace(/  +/g, ' ');

      let i, j, imax, jmax;
      let classesToDel = classname.split(' ');
      for (i = 0, imax = classesToDel.length; i < imax; ++i) {
        if (!classesToDel[i]) continue;
        let classtoDel = classesToDel[i];

        // https://jsperf.com/removeclass-methods
        let sClassName = '';
        let currentClasses = element.className.split(' ');
        for (j = 0, jmax = currentClasses.length; j < jmax; ++j) {
          if (!currentClasses[j]) continue;
          if (currentClasses[j] !== classtoDel) sClassName += currentClasses[j] + ' ';
        }
        element.className = sClassName.trim();
      }
      if (element.className === '') element.removeAttribute('class');
    }
  }
  hasClass(element, classname) {
    if (!element) return false;
    try {
      let s = element.getAttribute('class');
      return new RegExp('\\b' + classname + '\\b').test(s);
    } catch (e) {
      0;
      //console.log(element);
    }
    //return element.classList ? element.classList.contains(classname) : new RegExp('\\b'+ classname+'\\b').test(element.className);
  }
  parentsHasAttribute(element, attrname) {
    while (element) {
      if (!element.tagName) return false;
      if (element.tagName === 'BODY' || element.tagName === 'HTML') return false;
      try {
        if (element.hasAttribute(attrname)) {
          // error on svg element
          return true;
        }
      } catch (e) {
        0;
        //console.log(element);
        //return false;
      }
      element = element.parentNode;
    }
  }
  removeClasses(elms, classname) {
    for (let i = 0; i < elms.length; i++) {
      elms[i].classList.remove(classname);
    }
  }
  uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
  }
  sanitize(input, allowEndingDash = false) {
    const regex = allowEndingDash ? /[^A-Za-z0-9-]+/g : /[^0-9a-zA-Z-]+|[-]+$/g;
    const forbiddenChars = {
      'æ': 'ae',
      'ø': 'o',
      'å': 'aa',
      'ü': 'u',
      'ö': 'o',
      'ä': 'a',
      'š': 's',
      'ž': 'z',
      'ß': 'ss',
      'é': 'e',
      'ë': 'e',
      'ï': 'i',
      'ó': 'o',
      'ù': 'u'
    };
    input = input.toLowerCase();
    for (const [originalChar, replaceChar] of Object.entries(forbiddenChars)) {
      input = input.split(originalChar).join(replaceChar);
    }
    input = input.replace(/\s+/g, '-');
    input = input.replace(regex, '');
    input = input.replace(/-+/g, '-');
    return input;
  }
  isAdmin() {
    const urlParts = document.location.pathname.split('/');
    for (const urlPart of urlParts) {
      if (urlPart === "adminSecure" || urlPart === "AssetManager") {
        return true;
      }
    }
    return false;
  }
  exportToCsv() {
    const exportToCsvBtns = document.querySelectorAll('[data-csv-table-id]');
    if (!exportToCsvBtns) return;
    exportToCsvBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const filename = btn.dataset.csvFilename ? btn.dataset.csvFilename : 'data';
        const tableId = btn.dataset.csvTableId;
        if (!tableId) {
          console.error('Missing data-csv-table-id on button');
          return;
        }
        const table = document.querySelector(`#${tableId}`);
        if (!table) {
          console.error(`No table with id: ${tableId}`);
          return;
        }
        const rows = table.querySelectorAll('tr');
        const csv = [];

        // Loop gennem rækkerne i tabellen
        rows.forEach(row => {
          const rowData = [];
          const cols = row.querySelectorAll('td, th');

          // Loop gennem cellerne i rækken
          cols.forEach(col => {
            let cellText = col.innerText;
            // Fjern "- " hvis teksten starter med det
            if (cellText.startsWith('- ')) {
              cellText = cellText.substring(2);
            }
            rowData.push(cellText);
          });
          csv.push(rowData.join(';')); // Brug semikolon som separator
        });

        // Opret CSV-filens indhold
        const csvContent = '\uFEFF' + csv.join('\n'); // Tilføj BOM

        // Opret et download-link
        const hiddenElement = document.createElement('a');
        hiddenElement.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csvContent)}`;
        hiddenElement.target = '_blank';
        hiddenElement.download = filename;
        hiddenElement.click();
      });
    });
  }
  async getPluginData(plugin) {
    const formData = new FormData();
    formData.append('plugin', plugin);
    const response = await fetch('/global/ajaxHandlerGlobal.php?handler=getPluginData', {
      method: 'POST',
      body: formData
    });
    return await response.json();
  }
  patternPassword() {
    return '(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}';
  }
}